import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/companies';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

type CompanyQueryKey = ['company', { params: { companyId: string } }];

const fetchCompany = async ({ queryKey }: { queryKey: CompanyQueryKey }) => {
  const [, { params }] = queryKey;
  const { data } = await api.get<ApiResponse<Api.GetInvesteeResponse>>(
    `investee/list/${params.companyId}`,
  );
  return data.data;
};

function useCompany(companyId: string, refetchOnWindowFocus?: boolean) {
  return useQuery({
    queryKey: ['company', { params: { companyId } }],
    queryFn: fetchCompany,
    placeholderData: keepPreviousData,
    staleTime: refetchOnWindowFocus ? 0 : QUERY_STALE_TIME_MS,
    enabled: !!companyId,
    refetchOnWindowFocus,
  });
}

export default useCompany;
